import { render } from "./AdvancedModulesSection.vue?vue&type=template&id=4d15a222&scoped=true"
import script from "./AdvancedModulesSection.vue?vue&type=script&lang=js"
export * from "./AdvancedModulesSection.vue?vue&type=script&lang=js"

import "./AdvancedModulesSection.vue?vue&type=style&index=0&id=4d15a222&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d15a222"]])

export default __exports__